import { Route, Routes } from 'react-router-dom'
import Calendar from '../pages/calendar/Calendar'
import AddEvent from '../pages/calendar/addEvent/AddEvent'

const router = () => {
  return (
    <Routes>
      <Route path='/' element={<Calendar />} />
      <Route path='/add-event' element={<AddEvent />} />
    </Routes>
  )
}

export default router